
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const ProjectTrackingBlog = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 overflow-x-hidden">
      <Header />
      
      <main className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
        <Link 
          to="/blog" 
          className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-8 transition-colors min-h-[48px] touch-manipulation"
        >
          <ArrowLeft size={16} />
          Back to Blog
        </Link>
        
        <div className="bg-white rounded-2xl shadow-lg p-6 sm:p-8 md:p-12">
          <article>
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
              How Zimbabweans Abroad Can Track Building Projects With Confidence
            </h1>
            
            <p className="text-sm text-gray-500 mb-6 sm:mb-8">
              Published: July 2025
            </p>

            <div className="prose prose-sm sm:prose-lg max-w-none">
              <p className="text-lg sm:text-xl text-gray-600 mb-6 sm:mb-8 leading-relaxed">
                Diaspora Zimbabweans have long faced the heartbreak of sending money home for house projects — only to be ghosted by builders or scammed altogether. ZimKonnect is changing the narrative.
              </p>

              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-6 sm:mt-8 mb-3 sm:mb-4 flex items-center">
                <span className="mr-2">✅</span> Why Project Tracking Matters
              </h2>
              
              <ul className="list-disc pl-4 sm:pl-6 mb-4 sm:mb-6 text-gray-700 space-y-2">
                <li>$2.1 billion in diaspora remittances flowed into Zimbabwe in 2024 alone.</li>
                <li>Over 60% of that went to construction, health, or farming support.</li>
                <li>Yet scams, price inflation, and lack of transparency are a daily threat.</li>
              </ul>

              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-6 sm:mt-8 mb-3 sm:mb-4 flex items-center">
                <span className="mr-2">🧠</span> The ZimKonnect Solution
              </h2>

              <p className="text-gray-700 mb-4 sm:mb-6 leading-relaxed">
                ZimKonnect lets you:
              </p>

              <ul className="list-disc pl-4 sm:pl-6 mb-4 sm:mb-6 text-gray-700 space-y-2">
                <li>Track your house, farm, or business with visual updates</li>
                <li>Assign a trusted agent to verify progress</li>
                <li>Compare local supplier prices via the in-app verification tool</li>
                <li>Get notified when progress is uploaded — with real-time alerts</li>
              </ul>

              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-6 sm:mt-8 mb-3 sm:mb-4 flex items-center">
                <span className="mr-2">👷‍♀️</span> Verified Suppliers & Agents
              </h2>

              <p className="text-gray-700 mb-4 sm:mb-6 leading-relaxed">
                All agents and suppliers on the platform are vetted and profiled — reducing your risk.
              </p>

              <h2 className="text-xl sm:text-2xl font-bold text-gray-900 mt-6 sm:mt-8 mb-3 sm:mb-4 flex items-center">
                <span className="mr-2">🌍</span> Built for the Diaspora
              </h2>

              <p className="text-gray-700 mb-4 sm:mb-6 leading-relaxed">
                Whether you're in the UK, South Africa, or Canada, your project is just a few taps away from transparency.
              </p>

              <div className="bg-gradient-to-r from-blue-50 to-orange-50 p-4 sm:p-6 rounded-lg border border-blue-200 mt-6 sm:mt-8">
                <p className="text-base sm:text-lg font-semibold text-gray-900 mb-3 sm:mb-4">
                  Ready to track your Zimbabwe project with confidence?
                </p>
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
                  <Link 
                    to="/#join-waitlist" 
                    className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-4 sm:px-6 py-3 rounded-lg hover:from-blue-700 hover:to-blue-800 transition-all duration-200 font-semibold text-center min-h-[48px] flex items-center justify-center touch-manipulation"
                  >
                    Join the Waitlist
                  </Link>
                  <Link 
                    to="/#how-it-works" 
                    className="border border-blue-600 text-blue-600 px-4 sm:px-6 py-3 rounded-lg hover:bg-blue-50 transition-all duration-200 font-semibold text-center min-h-[48px] flex items-center justify-center touch-manipulation"
                  >
                    See How It Works
                  </Link>
                </div>
              </div>
            </div>
          </article>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ProjectTrackingBlog;
